import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { UserCog, X } from "lucide-react";

export const ImpersonationBanner = () => {
  const { user, checkAuth } = useAuth();
  if (!user?._impersonator) return null;
  const exit = async () => {
    try { await api.post("/superadmin/stop-impersonate"); } catch {}
    if (checkAuth) await checkAuth();
    window.location.href = "/app/superadmin";
  };
  return (
    <div data-testid="impersonation-banner"
      className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-amber-500/50 bg-amber-500/10 px-4 py-2.5 text-sm text-amber-700 dark:text-amber-300">
      <span className="flex items-center gap-2"><UserCog className="h-4 w-4" /> Viewing as <strong>{user.name}</strong> ({user.email}) — changes apply to their account.</span>
      <button onClick={exit} data-testid="exit-impersonation"
        className="inline-flex items-center gap-1 rounded-full bg-amber-600 px-3 py-1 text-xs font-semibold text-white transition-opacity hover:opacity-90"><X className="h-3 w-3" /> Exit impersonation</button>
    </div>
  );
};
